import { datadogRum } from '@datadog/browser-rum';

export default function initDatadog({ isProd }) {
    if (isProd) {
        datadogRum.init({
            applicationId: '065be6c0-823e-4dca-a456-25275eb8a575',
            clientToken: 'pub1bc89cfe2cfc245cef04c36f8ad301b9',
            site: 'datadoghq.com',
            service: 'rental-growth-web',
            sampleRate: 20,
            replaySampleRate: 50,
            trackInteractions: false,
            allowedTracingOrigins: [window.location.origin]
        });
    }
}
